import React, { useState, useContext } from 'react';
import PointContextMenu from './PointContextMenu';
import PolygonContextMenu from './PolygonContextMenu';
import LineContextMenu from './LineContextMenu';
import { Point, Polygon, Line } from '../../../context/context';
import { AppContext } from '../../../context/context';
import { useEditLayer } from '../../layer_panel/functions/layerFunctions';
import { useFeatureFlags } from '../../../services/featureFlags/useFeatureFlags';

interface PointContextMenuState {
  x: number;
  y: number;
  point: Point;
}
interface PolygonContextMenuState {
  x: number;
  y: number;
  polygon: Polygon;
}
interface LineContextMenuState {
  x: number;
  y: number;
  line: Line;
}

interface MapContextMenusManagerProps {
  contextMenu: PointContextMenuState | null;
  setContextMenu: (ctx: PointContextMenuState | null) => void;
  polygonContextMenu: PolygonContextMenuState | null;
  setPolygonContextMenu: (ctx: PolygonContextMenuState | null) => void;
  lineContextMenu: LineContextMenuState | null;
  setLineContextMenu: (ctx: LineContextMenuState | null) => void;
  // Point context menu handlers
  onEditPointStyle: (point: Point) => void;
  // Polygon context menu handlers
  onEditPolygonStyle: (polygon: Polygon) => void;
  onImportOSMLocations: (polygon: Polygon) => void;
  onGenerateMeetingPoints: (polygon: Polygon) => void;
  onGetPopulationData: (polygon: Polygon) => void;
  onRunSpatialAnalysis: (polygon: Polygon) => void;
  onCreateSpatialAnalysisTicket: (polygon: Polygon) => void;
  isCreatingSpatialAnalysisTicket?: boolean;
  // Line context menu handlers
  onEditLineStyle: (line: Line) => void;
  onDeleteLine: (line: Line) => void;
}


const MapContextMenusManager: React.FC<MapContextMenusManagerProps> = ({
  contextMenu,
  setContextMenu,
  polygonContextMenu,
  setPolygonContextMenu,
  lineContextMenu,
  setLineContextMenu,
  onEditPointStyle,
  onEditPolygonStyle,
  onImportOSMLocations,
  onGenerateMeetingPoints,
  onGetPopulationData,
  onRunSpatialAnalysis,
  onCreateSpatialAnalysisTicket,
  isCreatingSpatialAnalysisTicket = false,
  onEditLineStyle,
  onDeleteLine,
}) => {
  const context = useContext(AppContext);
  const global = context?.global;
  const editLayer = useEditLayer();
  const { isFeatureRuntimeEnabled, flags } = useFeatureFlags();

  return (
    <>
      <PointContextMenu
        contextMenu={contextMenu}
        onClose={() => setContextMenu(null)}
        onEditStyle={onEditPointStyle}
      />
      <PolygonContextMenu
        contextMenu={polygonContextMenu}
        onClose={() => setPolygonContextMenu(null)}
        onEditStyle={onEditPolygonStyle}
        onImportOSMLocations={onImportOSMLocations}
        onGenerateMeetingPoints={onGenerateMeetingPoints}
        onGetPopulationData={onGetPopulationData}
        onRunSpatialAnalysis={onRunSpatialAnalysis}
        canRunSpatialAnalysis={flags['spatial_analysis']?.enabled !== false}
        onCreateSpatialAnalysisTicket={onCreateSpatialAnalysisTicket}
        canImportOSMLocations={isFeatureRuntimeEnabled('import_osm_locations')}
        canGenerateMeetingPoints={isFeatureRuntimeEnabled('meeting_points_generator')}
        canGetPopulationData={isFeatureRuntimeEnabled('population_analysis')}
        isCreatingSpatialAnalysisTicket={isCreatingSpatialAnalysisTicket}
      />
      <LineContextMenu
        contextMenu={lineContextMenu}
        onClose={() => setLineContextMenu(null)}
        onEditStyle={onEditLineStyle}
        onDelete={onDeleteLine}
      />
    </>
  );
};

export default MapContextMenusManager; 
